<template>
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.00391 1L11.0039 11" stroke="currentColor" stroke-width="2"/>
    <path d="M11.0039 1L1.00391 11" stroke="currentColor" stroke-width="2"/>
  </svg>
</template>

